export default __webpack_public_path__ + "static/4-2-0-0-061d8fd7c460300cc208b156c572913b.jpg";